export const RegisterSteps: Array<{ title: string; width: number }> = [
  {
    title: 'Create Login',
    width: 136,
  },
  {
    title: 'Create Profile',
    width: 136,
  },
  {
    title: 'Select Units',
    width: 136,
  },
  {
    title: 'Select Unit(s) Location',
    width: 200,
  },
  {
    title: 'Summary',
    width: 110,
  },
  {
    title: 'Payment',
    width: 110,
  },
]

export const AddUnitsSteps: Array<{ title: string; width: number }> = [
  {
    title: 'Select Units',
    width: 136,
  },
  {
    title: 'Select Unit(s) Location',
    width: 200,
  },
  {
    title: 'Summary',
    width: 110,
  },
  {
    title: 'Payment',
    width: 110,
  },
]
